module.exports = __webpack_public_path__ + "static/media/javascript-algorithms-and-data-structures.3bedbdfe.png";